import imgMoney from '../../../../images/classic-in-bankMoney.png';
import './Bank.css';

export const Bank = () => {
    return (
        <div className="bank__container">
            <div className="bank__money-container">
                <span className="in-bank__money-text">В банке</span>
            </div>
            <div className="bank__money-container">
                <img src={imgMoney} alt="" className="bank__money-img" />
                <span className="bank__balance">
                    176.01 <span className="bank__balance-rub">р.</span>
                </span>
            </div>
        </div>
    );
};
